module.exports = __webpack_public_path__ + "files/0cb7730b2c77135795e10e3bde7a5d7c.png";